export const getDefaultAvailability = region => {
  const availability = (region === 'Stockholm') ? stockholm : partner
  // NOTE: Add a timestamp to trigger the useEffect that sets auto values
  return { ...availability, timestamp: Date.now() }
}

const stockholm = {
  availabilities: [
    
  ],
  priceAndPaymentRules: {
    priceTypes: [
      {
        type: 'TAXIMETER',
        paymentMethods: [
          'PayInCar',
          'TSABAccount'
        ],
        voucherEnabled: true
      },
      {
        type: 'FIXED',
        paymentMethods: [
          'PayInCar',
          'TravelClearingAccount',
          'TSABAccount',
          'CreditCard'
        ],
        voucherEnabled: true
      }
    ]
  },
  tripRules: {
    maxAllowedIntermediateStops: 4
  }
}

const partner = {
  availabilities: [
    
  ],
  priceAndPaymentRules: {
    priceTypes: [
      {
        type: 'FIXED',
        paymentMethods: [
          'PayInCar',
          'TravelClearingAccount',
          'TSABAccount',
          'CreditCard'
        ],
        voucherEnabled: false
      }
    ]
  },
  tripRules: {
    maxAllowedIntermediateStops: 0
  }
}
